const pathToRegex = (pattern: string): RegExp => {
  const regex = pattern
    .replace(/\[(.*?)\]/g, '[^/]+') // [id] => [^/]+
    .replace(/\//g, '\\/') // / => \/
  return new RegExp(`^${regex}$`)
}

const getCurrentPathClient = (): string => window.location.pathname

export const getCurrentPath = async (): Promise<string> => {
  // Client-side
  if (typeof window !== 'undefined') {
    return getCurrentPathClient()
  }

  // Server-side
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { headers } = require('next/headers')
  const headerList = await headers()
  const pathname = headerList.get('x-current-path')

  return pathname || ''
}

export const getRouteNameFromPath = (path: string): string => {
  const pathWithoutQuery = path.split('?')[0]
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { routeNames } = require('@/route-names')
  for (const pattern in routeNames) {
    const regex = pathToRegex(pattern)
    if (regex.test(pathWithoutQuery)) {
      return routeNames[pattern]
    }
  }
  return 'Unknown'
}

/**
 * Returns the route name based on the current path.
 * This is an isomorphic function that can be used in both client-side and server-side code.
 * @returns {Promise<string>} The name of the current route.
 */
export const getRouteName = async (): Promise<string> => {
  const currentPath = await getCurrentPath()
  return getRouteNameFromPath(currentPath)
}

/**
 * Returns the route name based on the current client-side path.
 *
 * This function is intended for **client-side only** usage.
 * Use it only in specific cases where asynchronous functions like `getRouteName` can't be used
 * (e.g., for integrations with tools like Datadog).
 *
 * For all other scenarios, prefer using `getRouteName()` instead.
 * @returns {string} The name of the current route.
 */
export const _getRouteNameClientSide = () => {
  const currentPath = getCurrentPathClient()
  return getRouteNameFromPath(currentPath)
}
